import { getAction, postAction, putAction, deleteAction } from '@/api/manage'

const PLUGIN_API_PREFIX = '/api/plugin/vehicle-plugin'

export const getList = (params) => getAction(`${PLUGIN_API_PREFIX}/plugin-vehicle/list`, params)

export const getDetail = (id) => getAction(`${PLUGIN_API_PREFIX}/plugin-vehicle/detail/${id}`)

export const create = (data) => postAction(`${PLUGIN_API_PREFIX}/plugin-vehicle/create`, data)

export const update = (data) => putAction(`${PLUGIN_API_PREFIX}/plugin-vehicle/update`, data)

export const remove = (id) => deleteAction(`${PLUGIN_API_PREFIX}/plugin-vehicle/delete/${id}`)
